import { useContext, useRef, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import { Form, Number, Select, Text } from '../../../Components/Form';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { getStatus, serverErrorHandler } from '../../../Utils/Helpers';
import DefaultImage from '../Assets/Images/default.png';
import Preview from '../Components/Preview';
import Signature from '../Components/Signature';
import UserFields from '../Components/UserFields';
import { IDCardContext } from '../Context/IDCardContext';
import { getIDCardTypes } from '../Utils/Helper';

const validationSchema = Yup.object({
  title: Yup.string()
    .typeError('عنوان الزامی است')
    .required('عنوان الزامی است')
    .max(190, 'عنوان نمی تواند بیشتر از 190 کاراکتر باشد'),
  type: Yup.number()
    .typeError('انتخاب نوع الزامی است')
    .required('انتخاب نوع الزامی است'),
  width: Yup.string().required('عرض الزامی است'),
  height: Yup.string().required('عرض الزامی است'),
  font_size: Yup.string().required('عرض الزامی است'),
  status: Yup.number()
    .typeError('انتخاب وضعیت الزامی است')
    .required('انتخاب وضعیت الزامی است'),
});

const Create = () => {
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const fileInput = useRef(null);
  const [serverErrors, setServerErrors] = useState({});
  const { post } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();
  const context = useContext(IDCardContext);
  const [imageLoaing, setImageLoading] = useState(false);
  const [changeIDCardLoading, setChangeIDCardLoading] = useState(false);
  const [image, setImage] = useState(undefined);
  const signatureRef = useRef(null);
  const [signatureLoading, setSignatureLoading] = useState(false);
  const [signitureFieldLoading, setSignatureFieldLoading] = useState(false);
  const [openSection, setOpenSection] = useState({
    section_one: false,
    section_two: false,
  });

  // useEffect(() => {
  //   getCompetitions();
  // }, []);

  // const getCompetitions = async () => {
  //   await get(
  //     '/competition?all=true',
  //     (res) => {
  //       context.competitions = res.data;
  //       setLoading(false);
  //     },
  //     (err) => {
  //       error('دریافت اطلاعات با خطا روبرو شد.');
  //       setLoading(false);
  //     },
  //   );
  // };

  const submitForm = async (values, setSubmitingForm) => {
    values['background_image'] = image;
    values['fields'] = context.fields;
    values['signature'] = context.signature;

    setFormSubmitLoaing(true);
    await post(
      '/id-card',
      values,
      (res) => {
        success(`آی دی کارت "${values?.title}" باموفقیت ایجاد شد.`);
        setFormSubmitLoaing(false);
        navigate('/id-card');
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`آی دی کارد "${values?.title}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };

  const onFileSelect = async () => {
    if (fileInput.current.files[0] === undefined) {
      fileInput.current.value = '';
      setImage(undefined);
    } else {
      setImageLoading(true);
      let url = `/file?location=id_card&public=0`;
      await post(
        url,
        { file: fileInput.current.files[0] },
        (res) => {
          setImage(res?.data?.path);
          setImageLoading(false);
        },
        (err) => {
          setImageLoading(false);
          error('هنگام ثبت اطلاعات خطایی رخ داده است');
        },
        true,
      );
    }
    // tempSave({file: file, title: 'test file'});
  };

  const addFieldToIDCart = async (field) => {
    setChangeIDCardLoading(true);
    const fields = [...context.fields];
    let fieldIndex = await fields.findIndex((f) => f.id === field?.id);
    if (fieldIndex !== -1) {
      setChangeIDCardLoading(false);
      return error('آیتم مورد نظر قبلا اضافه شده است');
    }
    await fields.push(field);
    context.fields = await fields;
    setChangeIDCardLoading(false);
  };

  const changeIDCardFields = async (id, name, value) => {
    setChangeIDCardLoading(true);
    const fields = [...context.fields];
    let fieldIndex = await fields.findIndex((f) => f.id === id);
    if (fieldIndex !== -1) {
      fields[fieldIndex][name] = await value;
      context.fields = await fields;
    }
    setChangeIDCardLoading(false);
  };

  const removeItem = async (id) => {
    setChangeIDCardLoading(true);
    const fieldsContext = [...context.fields];
    let filterFields = await fieldsContext?.filter((f) => f.id !== id);

    context.fields = await filterFields;
    setChangeIDCardLoading(false);
  };

  const onSignatureFileSelect = async () => {
    if (signatureRef.current.files[0] === undefined) {
      signatureRef.current.value = '';
      context.signature.background_image = null;
    } else {
      setSignatureLoading(true);
      let url = `/file?location=id_card&public=0`;
      await post(
        url,
        { file: signatureRef.current.files[0] },
        (res) => {
          context.signature.background_image = res?.data?.path;
          setSignatureLoading(false);
        },
        (err) => {
          setSignatureLoading(false);
          error('هنگام ثبت اطلاعات خطایی رخ داده است');
        },
        true,
      );
      setSignatureLoading(false);
    }
  };

  const onChangeSignatureField = async (name, value) => {
    setSignatureFieldLoading(true);
    const signatureCopy = await { ...context.signature };
    signatureCopy[name] = await value;
    context.signature = await signatureCopy;
    setSignatureFieldLoading(false);
  };

  const removeSignature = async () => {
    setSignatureLoading(true);
    context.signature = await {
      background_image: null,
      width: 0,
      height: 0,
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
    };
    setSignatureLoading(false);
  };

  return (
    <Master
      showFormSidebar={true}
      sidebarComponent={
        <UserFields
          addFieldToIDCart={addFieldToIDCart}
          changeIDCardFields={changeIDCardFields}
        />
      }
    >
      <TitleBar
        title='ایجاد آی دی کارت'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/id-card'
      />
      <Form
        initialValues={{
          title: '',
          with: '',
          height: '',
          type: 0,
          font_size: '',
          status: 1,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row p-2'>
          <div className='col-12 border border-info rounded px-0 overflow-hidden'>
            <div
              onClick={() =>
                setOpenSection((prevState) => ({
                  ...prevState,
                  section_one: !prevState?.section_one,
                }))
              }
              className='d-flex flex-row justify-content-between align-items-center bg-white p-2 border-bottom border-info c-pointer'
            >
              <span className='text-dark f-16 font-weight-bold'>
                اطلاعات اولیه کارت
              </span>
              <i
                className={`fas fa-chevron-${
                  openSection.section_one ? 'up' : 'down'
                } f-18`}
              ></i>
            </div>
            {openSection.section_one && (
              <div className='row p-2 my-2'>
                <div className='col-12 col-md-6'>
                  <Text
                    title='عنوان'
                    name='title'
                    serverError={serverErrors.title}
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <Select
                    options={getIDCardTypes()}
                    title='نوع کارت'
                    name='type'
                    optionLabel='label'
                    optionValue='value'
                    serverError={serverErrors.type}
                  />
                </div>

                <div className='col-12 col-md-6'>
                  <Number
                    title='سایز نوشته ها'
                    name='font_size'
                    serverError={serverErrors.font_size}
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <Number
                    title='عرض (cm)'
                    name='width'
                    serverError={serverErrors.width}
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <Number
                    title='ارتفاع (cm)'
                    name='height'
                    serverError={serverErrors.height}
                  />
                </div>

                <div className='col-12 col-md-6'>
                  <div className='form-group'>
                    <div className='d-flex flex-column justify-content-center align-items-center mt-1 mx-2'>
                      <label>تصویر روی کارت</label>
                      <input
                        type='file'
                        className='d-none'
                        ref={fileInput}
                        id={`background-image`}
                        onChange={() => onFileSelect()}
                      />
                      <img
                        onClick={() => {
                          let input =
                            document.getElementById(`background-image`);
                          input.click();
                        }}
                        className='bg-white img-thumbnail c-pointer'
                        style={{ width: '150px', height: '150px' }}
                        src={
                          image !== undefined && image.length > 0
                            ? image
                            : DefaultImage
                        }
                        alt='im'
                      />
                    </div>
                  </div>
                </div>

                <div className='col-12 col-md-6'>
                  <Select
                    title='وضعیت'
                    name='status'
                    optionLabel='label'
                    optionValue='value'
                    options={getStatus()}
                    serverError={serverErrors.status}
                  />
                </div>
              </div>
            )}
          </div>
          <div className='col-12 p-0 my-2'>
            <div className='border border-info rounded overflow-hidden'>
              <div
                onClick={() =>
                  setOpenSection((prevState) => ({
                    ...prevState,
                    section_two: !prevState?.section_two,
                  }))
                }
                className='d-flex flex-row justify-content-between align-items-center bg-white p-2 border-bottom border-info c-pointer'
              >
                <span className='text-dark f-16 font-weight-bold'>امضاء</span>
                <i
                  className={`fas fa-chevron-${
                    openSection.section_two ? 'up' : 'down'
                  } f-18`}
                ></i>
              </div>
              {openSection.section_two && (
                <Signature
                  context={context}
                  onChange={onChangeSignatureField}
                  signatureLoading={signatureLoading}
                  signatureRef={signatureRef}
                  onSignatureFileSelect={onSignatureFileSelect}
                />
              )}
            </div>
          </div>
          <div className='col-12'>
            <div className='row'>
              <div className='col-12 col-md-12'></div>
              <div className='col-12 col-md-12'>
                <Preview
                  loading={changeIDCardLoading}
                  imageLoading={imageLoaing}
                  context={context}
                  image={image}
                  removeItem={removeItem}
                  signatureLoading={signatureLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Create;
